import { useQuery } from 'react-query';
import getBuildFormUrlencodedParams from '../../utils/getBuildFormUrlencodedParams';
import iflexApi from '../iflexApi';

type Applications = {
  sistemas: {
    id_sis: string;
    nome_sis: string;
    url_sis: any;
    icone_sis: string;
  }[];
  favoritos: {
    id_siu: string;
    sistema_siu: string;
  }[];
};

async function getApplications(): Promise<Applications> {
  const data = getBuildFormUrlencodedParams({
    action: 'pegarSistemas',
    controller: 'Integrations/Analytics/Applications',
  });

  return '';
  const response = await iflexApi.post('', data);
  return response.data;
}

export function useApplications() {
  return useQuery(['applications'], () => getApplications(), {
    staleTime: 100,
  });
}
